import { Api } from "./Api.class";
const endpoint = "skill_categories";
const skillsCatAPI = new Api(endpoint);
export default skillsCatAPI;
